import { render, staticRenderFns } from "./ModalNewMessage.vue?vue&type=template&id=0c861078&scoped=true&"
import script from "./ModalNewMessage.vue?vue&type=script&lang=js&"
export * from "./ModalNewMessage.vue?vue&type=script&lang=js&"
import style0 from "./ModalNewMessage.vue?vue&type=style&index=0&id=0c861078&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c861078",
  null
  
)

export default component.exports